import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[app-phonenumber][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PhoneNumberValidator,
      multi: true
    }
  ]
})

export class PhoneNumberValidator implements Validator {
  validator: ValidatorFn;

  constructor() {
    this.validator = this.phoneValidator();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  phoneValidator(): ValidatorFn {
    return (c: FormControl) => {
      const isValid = /^\d{3}[\-]\d{3}[\-]\d{4}$/.test(c.value);
      if (isValid || c.value === '' || c.value === undefined) {
        return null;
      } else {
        return {
          phoneValidator: {
            valid: false
          }
        };
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/validators/phone-validator.component.ts